/**
 * CW-1287 alt-text feature flag (`NUXT_PUBLIC_ALT_TEXT_ENABLED`).
 * Set by `plugins/alt-text-feature.ts` at app init; `null` before init (unit tests use enabled).
 */

let altTextEnabled: boolean | null = null

export function setAltTextFeatureEnabled (value: boolean): void {
  altTextEnabled = value
}

export function isAltTextFeatureEnabled (): boolean {
  if (altTextEnabled === null) {
    return true
  }
  return altTextEnabled
}
